export default "__VITE_ASSET__DHMZ1luj__"